export class RowsIterator<T> {

    protected iterator: number = -1;

    protected columns: number = 2;

    protected arr: Array<Array<T>> = [];

    private data: Array<T>;

    private iteratorData: Array<any> = [];


    constructor(_data, columns = 2) {
        this.data = _data;
        this.columns = columns;
        this.arr = this.toArray();
    }

    public columnsCount() {
        if (this.columns == 5) {
            this.columns = 4;
        }
        return this.columns;
    }

    next(): Array<T> {
        this.iterator = this.iterator < 0 ? 0 : this.iterator + this.columns;
        return this.current();
    }

    current(): Array<T> {
        if (this.iterator === -1) {
            return null;
        }
        let res = [];
        //let cur = typeof this.data[this.iterator] !== 'undefined' ? this.data[this.iterator] : null;
        for (let i = this.iterator, j = 0; i < this.data.length && j < this.columns; i++, j++) {
            res.push(this.data[i]);
        }
        if (res.length === 0) {
            this.iterator = -1;
            return null;
        }
        return res;
    }

    length(): number {
        return Math.ceil(this.data.length / this.columns);
    }

    index(): number {
        return this.iterator;
    }

    first(): Array<T> {
        let prevIterator = this.iterator;
        this.iterator = -1;
        let res = this.current();
        this.iterator = prevIterator;
        return res;
    }

    last(): Array<T> {
        let prevIterator = this.iterator;
        this.iterator = this.length() - 1;
        let res = this.current();
        this.iterator = prevIterator;
        return res;
    }

    asArray(): Array<Array<T>> {
        return this.arr;
    }

    /**
     *
     * @returns {Array<Array<T>>}
     */
    toArray(): Array<Array<T>> {
        if (this.iteratorData.length === 0) {
            let res = [];
            this.iterator = -1;
            for (let i = 0; i < this.length(); i++) {
                res.push(this.next());
            }
            this.iteratorData = res;
        }
        return this.iteratorData;
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/rows.iterator.ts